import gql from 'graphql-tag';

import {
  AchievementDetails,
  AchievementLevelDetails,
} from '../fragments/achievements';

export const Achievements = gql`
  query achievements {
    achievements {
      total
      records {
        ...AchievementDetails
      }
    }
  }

  ${AchievementDetails}
`;

export const AchievementsWithAccount = gql`
  query achievementsWithAccount {
    me {
      id
      achievements(slice: { limit: 999 }) {
        records {
          id
          achievement_level {
            ...AchievementLevelDetails
            achievement {
              id
              ...AchievementDetails
            }
          }
          created_at
          updated_at
          viewed_at
        }
      }
      pending_achievement_levels(slice: { limit: 999 }) {
        records {
          ...AchievementLevelDetails
          achievement {
            id
            ...AchievementDetails
          }
        }
      }
    }
    achievements {
      total
      records {
        ...AchievementDetails
      }
    }
  }

  ${AchievementLevelDetails}
  ${AchievementDetails}
`;
